import { jsx as _jsx } from "react/jsx-runtime";
import { TransparencyOverlay } from "@faire/web--source/ui/TransparencyOverlay";
import React from "react";
export var OverlayStyle;
(function(OverlayStyle) {
    OverlayStyle[OverlayStyle["BACKORDERED"] = 0] = "BACKORDERED";
    OverlayStyle[OverlayStyle["DARKENING"] = 1] = "DARKENING";
    OverlayStyle[OverlayStyle["NONE"] = 2] = "NONE";
})(OverlayStyle || (OverlayStyle = {}));
export var Overlay = function(param) {
    var overlayStyle = param.overlayStyle;
    switch(overlayStyle){
        case OverlayStyle.BACKORDERED:
            return /*#__PURE__*/ _jsx("div", {
                className: "w-full h-full flex items-center justify-center absolute left-0 top-0 bg-core-surface-inverse/50"
            });
        case OverlayStyle.DARKENING:
            return /*#__PURE__*/ _jsx(TransparencyOverlay, {});
        default:
            return null;
    }
};
